
import {Vue, Component} from 'vue-property-decorator';
import {dictApi, dictInstrumentApi, roleApi, userApi} from "@/api/organization";
import baseUrl, {imageUrl} from '@/constants';
import {integrityApi} from "@/api/integrity";
import Credit from "@/views/integrity/Credit.vue";
import reasons from "@/components/Reasons.vue";
import list from "@/components/List.vue";
import ApplyDialog from "@/views/integrity/applyDialog.vue";
import {IPage} from "@/js/page";
import NameOneRowLen from "@/views/integrity/components/nameOneRowLen.vue";
const {regionData,CodeToText} =require("@/js/region/region");


@Component({
  components: {NameOneRowLen, ApplyDialog, reasons, Credit,list}
})
export default class OrderAudit extends Vue {
  private orders = []; // 已提交申请列表
  private activeName = "1";//选中的页签
  CodeToText = CodeToText;
  allSelected = [];
  showForm = false;
  form = {
    state: "",  //业务状态
    orgName: "",  //单位名称
    typeId: "", //行业类别
    region: "", //所在区域
    userName: "",  //发起人
    mobile: "",  //联系电话
    start: "", //公示日期开始时间
    end: "", //公示日期结束时间
  } as any
  listParam: IPage = {
    size: 10,
    current: 1,
  };
  listTotal = 0;
  statesList = [];  //行业类别
  regionData = regionData;
  violationNum = 0; // 违规单位数量
  baseUrl = baseUrl
  mounted() {
    //  加载行业列表
    this.getDict();
    //  加载已提交申请
    this.listBySate();
  }

  getViolation() {
    integrityApi.numberOfViolations().then(r => {
      if (r.data.result === 0) {
        const rData = r.data.data;
        this.violationNum = rData;
      }
    })
  }

  getDict() {
    return dictApi.listDictItem({
      typeCode: "hylb"
    }).then(r => {
      if (r.data.result === 0) {
        this.statesList = r.data.data;
      }
    })
  }

  tableLoading = false;
  listBySate() {
    // var userData = this.$store.state.AuthedUser;
    // const params = {
    //   state: this.activeName,
    //   org: userData.organizationId
    // }
    const params = {
      ...this.listParam,
      ...this.form,
    }
    this.tableLoading = true;
    let api = null as any;
    if (this.activeName === "record") {
      api = integrityApi.listRecord(params);
    } else {
      params.state = this.activeName;
      api = integrityApi.list(params);
    }
    api.then((r: any) => {
      if(r.data.result == 0){
        const rData = r.data.data;
        this.listTotal = rData.total;
        this.orders = rData.records;
        //  获取违规数量
        this.getViolation();
        this.$nextTick(() => {
          let $table = this.$refs.table as HTMLFormElement;
          if ($table) {
            $table.doLayout();
          }
        })
      }
    }).finally(() => {
      this.tableLoading = false;
    })
  }

  handleClick() {
    this.listParam.current = 1;
    this.listBySate();
    this.tableClearSelect();
  }

  memberSelect(selection: any, row: any) {
    this.allSelected = selection;
  }

  tableClearSelect() {
    this.allSelected = [];
    let $table = this.$refs.table as HTMLFormElement;
    if ($table) {
      $table.clearSelection();
    }
  }

  rightBtn(type: string) {
    const dataArr = this.allSelected as any;
    if (dataArr.length == 0) {
      this.$message.error("请先勾选");
      return;
    }
    if (type == 'generate') {
      // 重新生成承诺书
      if (dataArr.length === 1) {
        this.generateFun(dataArr[0])
      } else {
        this.$confirm("检测到勾选多条数据，默认证书名称不换行，确定要批量重新生成承诺书吗?","确认操作",{type:"warning"}).then(()=>{
          this.generateSubmitBatch(dataArr.flatMap((e: any) => e.id).join(','));
        })
      }
      return;
    }
    if (dataArr.length > 1) {
      this.$message.error("只能勾选一条");
      return;
    }
    if (type == 'clear') {
      this.clearFun(dataArr[0]);
    } else if (type == 'revoke') {
      this.revokeFun(dataArr[0]);
    } else if (type == 'return') {
      this.returnFun(dataArr[0]);
    } else if (type == 'clearRevoke') {
      // 取消撤销
      this.clearRevoke(dataArr[0])
    }else {
      this.toDetail(dataArr[0], type);
    }
  }

  // 取消撤销
  clearRevoke(row: any) {
    this.$confirm('确认取消“'+row.orgName+'”的撤销信息吗？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      integrityApi.unbanCancel({orgId: row.orgId}).then((r) => {
        if(r.data.result === 0){
          this.$message.success("操作成功");
          this.listBySate();
          this.tableClearSelect()
        }
      });
    });
  }

  // 清理
  clearFun(row: any) {
    this.$confirm('确认清理已经注销的企业：'+row.orgName+'吗？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      integrityApi.deleteIntegrity({ids: row.id}).then((r) => {
        if(r.data.result === 0){
          this.$message.success("操作成功");
          this.listBySate();
          this.tableClearSelect()
        }
      });
    });
  }

  // 撤销
  revokeData = {
    dialog: false,
    data: {} as any,
    time: '',
    revokeReason: ''
  }
  revokeFun(row: any) {
    this.revokeData.data = row;
    this.revokeData.dialog = true;
    this.revokeData.time = '';
    this.revokeData.revokeReason = '';
  }
  revokeSubmit() {
    if (!this.revokeData.time) {
      this.$message.error("撤销日期必填");
      return;
    }
    this.$confirm("确实要撤销"+this.revokeData.data.orgName+"的公示，并且在"+this.revokeData.time+"之前不允许再次提交申请?", "确认操作").then(() => {
      integrityApi.changeState({id: this.revokeData.data.id, state: 4,unbanTime:this.revokeData.time,revokeReason:this.revokeData.revokeReason}).then((r: any) => {
        if (r.data.result === 0) {
          this.$message.success("提交成功");
          this.revokeData.dialog = false;
          this.listBySate();
          this.tableClearSelect()
        }
      })
    })
  }

  // 退回
  returnData = {
    dialog: false,
    data: {} as any,
    revokeReason: ''
  }
  returnFun(row: any) {
    this.returnData.data = row;
    this.returnData.dialog = true;
    this.returnData.revokeReason = '';
  }
  returnSubmit() {
    if (!this.returnData.revokeReason) {
      this.$message.error("退回原因必填");
      return;
    }
    this.$confirm("确实要退回?", "确认操作").then(() => {
      integrityApi.changeState({id: this.returnData.data.id, state: 2,reason:this.returnData.revokeReason}).then((r: any) => {
        if (r.data.result === 0) {
          this.$message.success("提交成功");
          this.returnData.dialog = false;
          this.listBySate();
          this.tableClearSelect()
        }
      })
    })
  }

  rightBtnDownload(type: string) {
    const dataArr = this.allSelected as any;
    if (dataArr.length == 0) {
      this.$message.error("请先勾选");
      return;
    }
    if (type == 'download') {
      // 下载承诺书
      integrityApi.downloadPromises({ids: dataArr.flatMap((e: any) => e.id).join(',')}).then((r: any) => {
        if (r.data.result === 0) {
          window.open(baseUrl + "/file/download?file=" + r.data.data + "&name=" + "承诺书.zip", '_blank');
        }
      })
    } else if (type == 'export') {
      // 导出xlsx数据
      integrityApi.exportData({ids: dataArr.flatMap((e: any) => e.id).join(',')}).then((r: any) => {
        if (r.data.result === 0) {
          window.open(baseUrl + "/file/download?file=" + r.data.data + "&name=" + "承诺单位导出.xlsx", '_blank');
        }
      })
    }
  }

  // 重新生成******************************
  generateData = {
    dialog: false,
    data: {} as any
  }
  generateFun(row: any) {
    this.generateData.data = row;
    this.generateData.dialog = true;
  }
  generateSubmit() {
    const loading = this.$loading({
      text: '正在生成,请稍后...',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    integrityApi.generateSpecialMark({ids: this.generateData.data.id, wordNumber: (this.$refs.nameOneRowLen as any).getNumber()}).then((r: any) => {
      if (r.data.result === 0) {
        this.$message.success("生成成功");
        this.listBySate();
        this.tableClearSelect()
        this.generateData.dialog = false;
      }
    }).finally(() => {
      loading.close();
    })
  }
  // 批量设置
  generateSubmitBatch(ids: string) {
    const loading = this.$loading({
      text: '正在生成,请稍后...',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    integrityApi.generateSpecialMark({ids: ids, wordNumber: 100}).then((r: any) => {
      if (r.data.result === 0) {
        this.$message.success("生成成功");
        this.listBySate();
        this.tableClearSelect()
      }
    }).finally(() => {
      loading.close();
    })
  }
  // 重新生成end******************************

  toDetail(row: any, type: string) {
    // 改变状态  1 待审核
    if (this.activeName == '1') {
      integrityApi.changeHandle(row.id).then(() => {
        this.listBySate();
      })
    }
    (this.$refs.applyDialog as any).toDetail(row, type);
  }

  reset(){
    for(const f in this.form){
      this.form[f] = "";
    }
    this.refresh();
  }
  refresh() {
    this.showForm = false;
    this.tableClearSelect()
    this.listBySate();
  }

  pageSizeChange(val: number) {
    this.listParam.size = val;
    this.refresh();
  }
  pageCurrentChange(val: number) {
    this.listParam.current = val;
    this.listBySate();
  }

  downloadPdf(row: any) {
    window.open(baseUrl + "/file/download?file=" + row.promiseCreateUrl + "&name=" + row.orgName + "公示承诺书.pdf", '_blank');
  }

  // 显示处罚信息
  punishData = {
    dialog: false,
    data: null as any
  }
  showPunish(row: any) {
    this.punishData.data = row;
    this.punishData.dialog = true;
  }
}
